document.addEventListener("DOMContentLoaded", async () => {
  // SWIPERS START
  const ddBottomSwiper = new Swiper(".dd-swiperBottom", {
    loop: false,
    spaceBetween: 10,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
    on: {
      init: function () {
        previousActiveIndex = this.activeIndex;
      },
      click: function () {
        // console.log("this.activeIndex",this.activeIndex)
        // console.log("this.clickedIndex",this.clickedIndex)
        // console.log("previousActiveIndex",previousActiveIndex)

        if (this.clickedIndex < previousActiveIndex) {
          // console.log("Left");
          this.slideTo(this.clickedIndex - 1, 300, true);
          // console.log(this.clickedIndex - 1);
        } else {
          this.slideTo(this.clickedIndex, 300, true);
        }
        previousActiveIndex = this.clickedIndex;
        // console.log("-----------",)
      },
    },
  });

  const ddTopSwiper = new Swiper(".dd-swiperTop", {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: ddBottomSwiper,
    },
  });

  const parallaxSwiper = new Swiper(
    ".camping-outside-fluid-swiper-container .swiper",
    {
      speed: 600,
      parallax: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    }
  );

  const productSwiper = new Swiper(
    ".camping-out-vehicle-slider-container .swiper",
    {
      pagination: {
        el: ".swiper-pagination.vehicle-swiper",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    }
  );
  // SWIPERS END

});
